/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const DistributeSpaceHorizIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Distribute Space Horiz',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <rect height="24" rx="1" ry="1" width="10" x="4" y="10" />
    <rect height="16" rx="1" ry="1" width="12" x="20" y="12" />
    <path
      d="M20 7.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V4h3.5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H22V.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V2h-6V.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5V2H8.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H12v3.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V4h6Z"
    />
  </svg>`;
};
